import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'gstar-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  @Input() image!: string;
  @Input() description!: string;
  @Input() title!: string;

  redirectToRoot(): void {
    this.router.navigate(['/']);
  }

  goBack(): void {
    this.location.back();
  }
}
